export { default } from './SocialNetworks';



// WEBPACK FOOTER //
// ./src/client/js/view/components/Footer/SocialNetworks/index.js